"use strict";

import React from "react";
import _ from "lodash";
import Modal from "../base/Modal";
import DesignChooserStore from "../../stores/DesignChooserStore";
import DesignChooser from "./DesignChooser.jsx";
import AppConfig from "../../config/app";

class DesignChooserModal extends React.Component {
  state = DesignChooserStore.getState();

  componentDidMount() {
    this.chooserStoreUnsubscribe = DesignChooserStore.listen(this._onStoreChange);
  }

  componentWillUnmount() {
    this.chooserStoreUnsubscribe();
  }

  _onStoreChange = () => {
    this.setState(DesignChooserStore.getState());
  };

  render() {
    const { title } = this.state;
    let modalProps = _.pick(this.props, Modal.BASIC_PROPS);

    return (
      <Modal {...modalProps} style={{ width: "100%", height: "100%" }}>
        <Modal.Dialog id="design_chooser">
          <Modal.Dialog.Header closeButton>
            <Modal.Dialog.Title>{title}</Modal.Dialog.Title>
          </Modal.Dialog.Header>
          <Modal.Dialog.Body style={{ padding: 0, height: "100%" }}>
            <DesignChooser {...this.state} demoMode={AppConfig.demoMode} />
          </Modal.Dialog.Body>
        </Modal.Dialog>
      </Modal>
    );
  }
}

export default DesignChooserModal;
